import React from 'react';
import { Link } from 'react-router-dom';
import Container from './styles';

const NotFound = () => {
  const isLoggedIn = localStorage.getItem('currentUser');
  const link = <Link to="/login">Login</Link>;
  return (
    <Container>
      <h1>Page Not Found</h1>
      <p>{!isLoggedIn && link}</p>
    </Container>
  );
};

export default NotFound;
